import { beads, Bead } from '../beads.js';
import { settings } from '../settings.js';

const applyCircle = () => {
    let centerX = 600;
    let centerY = 600;
    beads.arr[0].x = centerX;
    beads.arr[0].y = centerY;

    let counter = 1;

    let addCircle = (radius, number) => {
        for (let i = 0; i < number; i++) {
            let x = centerX + (radius * 38 * Math.sin(i * 2 * Math.PI / number));
            let y = centerY + (radius * 38 * Math.cos(i * 2 * Math.PI / number));
            beads.arr[counter].x = x;
            beads.arr[counter].y = y;
            counter++;
        }
    };

    // deal with legacy files... default settings.rows!
    if (settings.columns !== 0) {
        settings.rows = 8;
        settings.columns = 0;
    }

    for (let i = 1; i < settings.rows; i++) {
        addCircle(i, i * 6);
    }

    beads.arr.forEach((_bead, i) => {
        if (i >= counter) {
            _bead.ignore = true;
        }
    });
};


export const plasticConfig = [
    {
        name: 'plastic_loom',
        displayName: 'Square',
        colDist: () => 38,
        rowDist: () => 38,
        offset: () => 0,
        offsetPattern: [0],
        apply: null,
        canSelectCommute: false,
        canSelectDirection: false,
        canSelectStartingBead: false,
        canSelectPanelWidth: true,
        canExportSmallDiagrams: true,
        plastic: true,
        noCustomBeadSize: true,
        getDimensions: (myRows, myColumns, diameter, beadLength) => {
            return {
                width: myColumns * diameter / 10,
                height: myRows * beadLength / 10
            };
        },
        disabledTools: ['Row Shift', 'Star'],
        arrangeGrid: true
    },
    {
        name: 'plastic_brick',
        displayName: 'Brick (fuse)',
        colDist: () => 36,
        rowDist: () => 32,
        offset: () => -18,
        offsetPattern: [0, 1],
        apply: null,
        canSelectCommute: false,
        canSelectDirection: false,
        canSelectStartingBead: false,
        canSelectPanelWidth: false,
        canExportSmallDiagrams: true,
        plastic: true,
        noCustomBeadSize: true,
        brickDrag: true,
        getDimensions: (myRows, myColumns, diameter, beadLength) => {
            return {
                width: myColumns * diameter / 10,
                height: myRows * beadLength / 10
            };
        },
        disabledTools: ['Row Shift', 'Star'],
        transform60: true,
        arrangeGrid: true
    },
    {
        name: 'plastic_round',
        displayName: 'Round',
        simpleExport: true,
        plastic: true,
        canSelectCommute: false,
        canSelectDirection: false,
        canSelectStartingBead: false,
        canSelectPanelWidth: false,
        canExportSmallDiagrams: false,
        noCustomBeadSize: true,
        noChangePattern: true,
        noDrag: true,
        beadFromPoint: true,
        noColumns: true,
        rowLimit: 15,
        create: () => {
            for (let i = 0; i < 1000; i++) {
                let j = Math.floor(i / 10);
                beads.arr.push(new Bead(j, i));
            }
        },
        colDist: () => 50,
        rowDist: () => 50,
        offset: () => 0,
        offsetPattern: [0],
        apply: null,
        getDimensions: (myRows, myColumns, diameter, beadLength) => {
            return {
                width: myRows * 0.94,
                height: myRows * 0.94
            };
        },
        getExportImageDimensions: rows => {
            return {
                width: 1500, height: 1500
            }
        },
        newProject() {
            applyCircle();
        },
        disabledTools: ['Row Shift', 'Bead Mode', 'Paint', 'Star'],
        getRowsAndColumns: ({rows, columns, size}) => {
            rows = size;
            columns = 0; // not used
            return [rows, columns];
        },
        useSingleRenderTexture: true,
        manualFindBead: true,
        getRTLocation() {
            return [0, 0];
        }
    }
]